import { Facebook, Linkedin, Mail } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { CONTACT, NAV_LINKS } from "@/data/content";
import { handleAnchorClick } from "@/lib/scroll";

export const Footer = () => {
  const year = new Date().getFullYear();
  const soon = (e) => {
    e.preventDefault();
    toast("Coming soon.");
  };

  return (
    <footer className="relative border-t border-white/10 bg-navy-800/60" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-6">
            <Logo imgClass="h-20" />
            <p className="mt-5 max-w-sm font-display text-base font-medium text-slate-200 leading-relaxed">
              Built by lived experience. Powered by technology. Designed for independence.
            </p>
          </div>

          <nav className="md:col-span-3" aria-label="Footer">
            <h2 className="text-xs font-mono uppercase tracking-[0.2em] text-teal">Explore</h2>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => handleAnchorClick(e, l.href)}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h2 className="text-xs font-mono uppercase tracking-[0.2em] text-teal">Connect</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4" aria-hidden="true" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 pt-1">
                <a
                  href={CONTACT.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Aiga Enable on LinkedIn"
                  className="inline-flex h-11 w-11 sm:h-8 sm:w-8 items-center justify-center text-slate-300 hover:text-white transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-navy-800"
                  data-testid="footer-linkedin"
                >
                  <Linkedin className="h-5 w-5" aria-hidden="true" />
                </a>
                <a
                  href={CONTACT.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Aiga Enable on Facebook"
                  className="inline-flex h-11 w-11 sm:h-8 sm:w-8 items-center justify-center text-slate-300 hover:text-white transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-navy-800"
                  data-testid="footer-facebook"
                >
                  <Facebook className="h-5 w-5" aria-hidden="true" />
                </a>
              </li>
              <li className="flex gap-4 pt-1">
                <a href="#privacy" onClick={soon} className="text-sm text-slatemuted hover:text-white transition-colors" data-testid="footer-privacy">Privacy</a>
                <a href="#terms" onClick={soon} className="text-sm text-slatemuted hover:text-white transition-colors" data-testid="footer-terms">Terms</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-6">
          <p className="text-sm text-slatemuted">© {year} Aiga Enable</p>
          <p className="text-xs font-mono uppercase tracking-[0.18em] text-slatemuted">
            Aotearoa New Zealand
          </p>
        </div>
      </div>
    </footer>
  );
};
